import React from 'react';
import { getClubs, initiateEnrollment, testCharge, testRefund } from "../../api/clubapi";
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, InputGroup, InputGroupText, Button, Label, Form, FormGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';
import '../css/View.css';

class ClubEnrollment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clubs: [],
            loading: true,
            value: '',
            toggle: false,
            toggledClub: {}
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        console.log("component did mount");
        this.props.getClubs(function (result, _this) { }, this, this.state.value)
        this.setState({
            loading: true
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.clubs !== prevProps.clubs) {
            this.setState({
                clubs: this.props.clubs,
                loading: false
            });
        }
        if (this.props.operations !== prevProps.operations) {
            this.setState({
                operations: this.props.operations
            });
        }
    }

    handleEnrollment(club) {
        if (club.url) {
            window.location.href = club.url;
        }
        else {
            this.props.initiateEnrollment(club.clubId);
        }
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    isEnrolled(club) {
        return club.stripeMerchantId ? true : false;
    }

    isCharged(club) {
        if (club.charge) {
            return club.charge.chargeId ? true : false;
        }

        return false;
    }

    isRefundAllowed(club) {
        return club.refundId ? false : (this.isCharged(club) ? true : false);
    }

    handleCharge(club) {
        if (this.isCharged(club)) {
            window.open(`https://dashboard.stripe.com/${club.charge.accountId}/test/payments/${club.charge.chargeId}`, '_blank');
        }
        else {
            this.toggleModal();
            this.setState({ toggledClub: club });
        }
    }

    handleRefund(club) {
        this.toggleModal();
        this.setState({ toggledClub: club });
    }

    toggleModal() {
        this.setState(prevState => ({
            toggle: !prevState.toggle
        }));
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.isCharged(this.state.toggledClub)) {
            if (parseInt(this.amount.value) > parseInt(this.state.toggledClub.charge.amount)) {
                alert("Amount to refund cannot be greater than charged one");
            }
            else {
                this.toggleModal();
                this.props.testRefund(this.state.toggledClub.clubId, this.state.toggledClub.charge.chargeId, this.amount.value);
            }
        }
        else {
            this.toggleModal();
            this.props.testCharge(this.state.toggledClub.clubId, this.amount.value);
        }
    }

    render() {
        const columns = [{
            Header: () => (
                <div
                    style={{
                        textAlign: "left",
                    }}
                >Club name <FontAwesomeIcon icon="sort" size="sm" /></div>),
            accessor: 'name',
            width: 300,
            style: {
                marginLeft: 15,
                borderRight: '1.5px dotted',
                borderColor: 'rgba(117, 117, 117, 0.6)'
            }
        }, {
            Header: () => (
                <div>Club code <FontAwesomeIcon icon="sort" size="sm" /></div>),
            accessor: 'clubCode',
            style: {
                textAlign: 'center',
                borderRight: '1.5px dotted',
                borderColor: 'rgba(117, 117, 117, 0.6)'
            }
        }, {
            Header: 'More Options',
            sortable: false,
            Cell: (row =>
                <div className="col-sm">
                    {
                        !this.isEnrolled(row.original) && !row.original.url ? <div className="row text-center"><Button style={{ marginTop: '0px', whiteSpace: 'normal' }} onClick={() => this.handleEnrollment(row.original)} disabled={this.isEnrolled(row.original)}>Generate Authorization Url</Button></div>
                            : <div className="row">
                                <Button style={{ marginTop: '0px' }} onClick={() => this.handleEnrollment(row.original)} disabled={this.isEnrolled(row.original)}>Authorize</Button>
                                <Input type="textarea" disabled={this.isEnrolled(row.original)} defaultValue={row.original.url} />
                            </div>
                    }
                </div>
            ),
            style: {
                userSelect: "none",
                textAlign: 'center',
            }
        }]
        return (
            <div >
                <ReactTable
                    columns={columns} data={this.state.clubs}
                    pageSize={this.state.clubs.length > 0 ? this.state.clubs.length : 5}
                    loading={this.state.loading}
                    showPagination={false}
                    noDataText={this.state.loading ? " " : <div>
                        No results found</div>}
                />

                <div>
                    <Modal isOpen={this.state.toggle} toggle={this.toggleModal}>
                        <ModalHeader toggle={this.toggleModal}></ModalHeader>
                        <ModalBody style={{ textAlign: "center" }}>
                            <Form>
                                <FormGroup className="row">
                                    <Label className="col-sm-2" htmlFor="amount" style={{ marginTop: '7px' }}>Amount</Label>
                                    <div className="col-sm-8">
                                        <InputGroup>
                                            <InputGroupText addonType="prepend">$</InputGroupText>
                                            <Input type="number" id="amount" name="amount"
                                                innerRef={(input) => this.amount = input} defaultValue={this.isCharged(this.state.toggledClub) ? this.state.toggledClub.charge.amount : null} />
                                        </InputGroup>
                                    </div>
                                    <Label className="col-sm-1" style={{ color: 'grey', marginTop: '7px' }}>USD</Label>
                                </FormGroup>
                                <FormGroup>
                                    <Button style={{ marginRight: '10px' }} onClick={this.handleSubmit} color="success">{this.isCharged(this.state.toggledClub) ? 'Refund' : 'Charge'}</Button>
                                    <Button className="btn-color-cancel" onClick={this.toggleModal}>Cancel</Button>
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        return {
            clubs: state.data.clubs
        }
    },
    dispatch => ({
        getClubs: (callback, context, filter) => { dispatch(getClubs(callback, context, filter)) },
        initiateEnrollment: (clubId) => { dispatch(initiateEnrollment(clubId)) },
        testCharge: (clubId, amount) => { dispatch(testCharge(clubId, amount)) },
        testRefund: (clubId, chargeId, amount) => { dispatch(testRefund(clubId, chargeId, amount)) },
    })
)(ClubEnrollment);
